import constants from "./constants";
import { getDashboardData } from "./services";

export function getDashboard() {
  const begin = () => ({ type: constants.GET_DASHBOARD_BEGIN });
  const success = data => ({
    type: constants.GET_DASHBOARD_SUCCESS,
    payload: data,
  });
  const failure = error => ({
    type: constants.GET_DASHBOARD_FAILURE,
    payload: error,
  });

  return async dispatch => {
    dispatch(begin());
    getDashboardData()
      .then(data => {
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions.js